import { UserFormFieldsNames, TUserFormValues } from '../helpers/types';
import { UserStatus, IUpdateUserDTO } from '@/models/users.model';
import { IFullAddress } from '@/models/addresses.model';

class UserProfileDTO implements IUpdateUserDTO {
  id?: string;
  email?: string;
  full_name?: string;
  phone_number?: string;
  status?: UserStatus;
  address?: IFullAddress;
  invoice_address?: IFullAddress;

  constructor(values: TUserFormValues, id?: string | null) {
    if (id) {
      this.id = id;
    } else {
      this.email = values[UserFormFieldsNames.EMAIL];
    }
    this.status = values[UserFormFieldsNames.STATUS];
    this.full_name = values[UserFormFieldsNames.NAME];
    this.phone_number = values[UserFormFieldsNames.PHONE_NUMBER];
    this.address = values[UserFormFieldsNames.ADDRESS];
    this.email = values[UserFormFieldsNames.EMAIL];
    this.invoice_address = values[UserFormFieldsNames.INVOICE_ADDRESS];
  }
}

export default UserProfileDTO;
